// src/pages/Contact.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

export default function Contact() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-20">
      {/* ============================
          SEO
      ============================ */}
      <Helmet>
        <title>Contact Aerzen Air™ | Sales & Support</title>
        <meta
          name="description"
          content="Contact Aerzen Air™ for product enquiries, support, partnerships, or air purification consultations. Reach us via phone or email."
        />
        <link
          rel="canonical"
          href="https://www.aerzenair.com/contact"
        />
      </Helmet>

      {/* HEADER */}
      <div className="mb-14">
        <span className="inline-block mb-3 px-3 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
          Contact
        </span>

        <h1 className="text-4xl font-bold mb-4">
          We’re Here to Help
        </h1>

        <p className="text-gray-700 max-w-3xl">
          At <strong>AERZEN AIR™</strong>, we believe in transparent communication
          and responsible support. Whether you have a question, need clarification,
          or want to understand our approach better, we’re available to assist.
        </p>
      </div>

      {/* CONTENT */}
      <div className="grid md:grid-cols-2 gap-12">
        {/* LEFT */}
        <div>
          <p className="text-gray-700 mb-6">
            Our team responds with clarity and intent — without automated replies
            or unnecessary redirection. We aim to keep communication simple,
            respectful, and useful.
          </p>

          <p className="text-gray-700">
            If you are evaluating air purification solutions, participating in a
            pilot initiative, or seeking post-deployment information, feel free
            to reach out.
          </p>
        </div>

        {/* RIGHT */}
        <div className="bg-gray-50 rounded-2xl p-8 space-y-4 text-gray-700">
          <p>
            <strong>Email:</strong><br />
            support@airzenair.com
          </p>

          <p>
            <strong>Phone:</strong><br />
            +91 95404 04657
          </p>

          <p>
            <strong>Location:</strong><br />
            Greater Noida, Uttar Pradesh, India
          </p>

          <p className="text-sm text-gray-500 pt-4">
            We typically respond within one working day.
          </p>
        </div>
      </div>
    </section>
  );
}
